import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  name: 'mepcoDate',
  standalone: true,
})
export class MepcoDatePipe implements PipeTransform {
  transform(value: any, format: string = 'MM/DD/YYYY', timezone: string = 'America/Chicago'): string {
    if (!value) return '';

    if (format === 'mediumDate') return moment(value).tz(timezone).format('MMM D, YYYY');

    if (timezone == 'local') {
      return moment(value).format(format);
    } else {
      return moment(value).tz(timezone).format(format);
    }
  }
}
